import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) nav(loc.state?.from || "/admin");
    else setErr(r.error);
  };

  return (
    <div data-testid="login-page" className="min-h-screen bg-black text-white flex items-center justify-center px-6">
      <div className="w-full max-w-md border border-zinc-800 bg-zinc-950/60 p-8 md:p-10">
        <Link to="/" data-testid="login-back-home" className="font-mono text-[10px] tracking-[0.3em] text-zinc-500 hover:text-sky-400 uppercase">← Back to home</Link>
        <h1 className="mt-4 font-display text-3xl md:text-4xl uppercase">Sign in</h1>
        <p className="text-zinc-500 text-sm mt-2">Καλως ηρθες πισω στο TED.</p>

        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <Field label="Email" type="email" value={email} onChange={setEmail} testid="login-email" />
          <Field label="Password" type="password" value={password} onChange={setPassword} testid="login-password" />
          {err && <div data-testid="login-error" className="text-red-400 text-xs font-mono">{err}</div>}
          <button
            type="submit"
            disabled={busy}
            data-testid="login-submit"
            className="w-full bg-sky-400 text-black font-bold uppercase tracking-widest py-3 hover:bg-sky-300 transition-colors disabled:opacity-40"
          >
            {busy ? "..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}

function Field({ label, type, value, onChange, testid }) {
  return (
    <label className="block">
      <span className="font-mono text-[10px] tracking-[0.3em] text-zinc-500 uppercase">{label}</span>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required
        data-testid={testid}
        className="mt-2 w-full bg-black border border-zinc-800 text-white px-4 py-3 focus:outline-none focus:border-sky-400 transition-colors"
      />
    </label>
  );
}
